module.exports = __webpack_public_path__ + "img/SiGe-barrier.991dfcae.svg";